module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v(_vm._s(_vm.item))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-389c991a!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/groups/CustomFieldAutoCompleteTemplate.vue
// module id = 725
// module chunks = 1